<div class="card" id="pdf-pages">
  <!-- Child Compoent: PDF Pages -->
  <app-aul-000-24 [policyDetails]="this.policyDetails()"></app-aul-000-24>
  <br />
  @if(this.policyDetails()?.aul_013_24?.stateId === 1){
  <!-- Alabama -->
  <app-albama-state-form
    [policyDetails]="this.policyDetails()"
  ></app-albama-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 2){
  <!-- Alaska -->
  <app-alaska-state-form
    [policyDetails]="this.policyDetails()"
  ></app-alaska-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 3){
  <!-- Arizona -->
  <app-arizona-state-form
    [policyDetails]="this.policyDetails()"
  ></app-arizona-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 4){
  <!-- Arkansas -->
  <app-arkansas-state-form
    [policyDetails]="this.policyDetails()"
  ></app-arkansas-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 5){
  <!-- California -->
  <app-california-state-form
    [policyDetails]="this.policyDetails()"
  ></app-california-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 6){
  <!-- Colorado -->
  <app-colorado-state-form
    [policyDetails]="this.policyDetails()"
  ></app-colorado-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 7){
  <!-- Connecticut -->
  <app-connecticut-state-form
    [policyDetails]="this.policyDetails()"
  ></app-connecticut-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 8){
  <!-- Delaware -->
  <app-delaware-state-form
    [policyDetails]="this.policyDetails()"
  ></app-delaware-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 9){
  <!-- Florida -->
  <app-aul-013-24 [policyDetails]="this.policyDetails()"></app-aul-013-24>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 10){
  <!-- Georgia -->
  <app-georgia-state-form
    [policyDetails]="this.policyDetails()"
  ></app-georgia-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 11){
  <!-- Hawaii -->
  <app-hawaii-state-form
    [policyDetails]="this.policyDetails()"
  ></app-hawaii-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 12){
  <!-- Idaho -->
  <app-idaho-state-form
    [policyDetails]="this.policyDetails()"
  ></app-idaho-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 13){
  <!-- Illinois -->
  <app-illinois-state-form
    [policyDetails]="this.policyDetails()"
  ></app-illinois-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 14){
  <!-- Indiana -->
  <app-indiana-state-form
    [policyDetails]="this.policyDetails()"
  ></app-indiana-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 15){
  <!-- Iowa -->
  <app-iowa-state-form
    [policyDetails]="this.policyDetails()"
  ></app-iowa-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 16){
  <!-- Kansas -->
  <app-kansas-state-form
    [policyDetails]="this.policyDetails()"
  ></app-kansas-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 17){
  <!-- Kentucky -->
  <app-kentucky-state-form
    [policyDetails]="this.policyDetails()"
  ></app-kentucky-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 18){
  <!-- Louisiana -->
  <app-louisiana-state-form
    [policyDetails]="this.policyDetails()"
  ></app-louisiana-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 19){
  <!-- Maine -->
  <app-maine-state-form
    [policyDetails]="this.policyDetails()"
  ></app-maine-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 20){
  <!-- Maryland -->
  <app-maryland-state-form
    [policyDetails]="this.policyDetails()"
  ></app-maryland-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 21){
  <!-- Massachusetts -->
  <app-massachusetts-state-form
    [policyDetails]="this.policyDetails()"
  ></app-massachusetts-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 22){
  <!-- Michigan -->
  <app-michigan-state-form
    [policyDetails]="this.policyDetails()"
  ></app-michigan-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 23){
  <!-- Minnesota -->
  <app-minnesota-state-form
    [policyDetails]="this.policyDetails()"
  ></app-minnesota-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 24){
  <!-- Mississippi -->
  <app-mississippi-state-form
    [policyDetails]="this.policyDetails()"
  ></app-mississippi-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 25){
  <!-- Missouri -->
  <app-missouri-state-form
    [policyDetails]="this.policyDetails()"
  ></app-missouri-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 26){
  <!-- Montana -->
  <app-montana-state-form
    [policyDetails]="this.policyDetails()"
  ></app-montana-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 27){
  <!-- Nebraska -->
  <app-nebraska-state-form
    [policyDetails]="this.policyDetails()"
  ></app-nebraska-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 28){
  <!-- Nevada -->
  <app-nevada-state-form
    [policyDetails]="this.policyDetails()"
  ></app-nevada-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 29){
  <!-- New Hampshire -->
  <app-new-hampshire-state-form
    [policyDetails]="this.policyDetails()"
  ></app-new-hampshire-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 30){
  <!-- New Jersey -->
  <app-new-jersey-state-form
    [policyDetails]="this.policyDetails()"
  ></app-new-jersey-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 31){
  <!-- New Mexico -->
  <app-new-mexico-state-form
    [policyDetails]="this.policyDetails()"
  ></app-new-mexico-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 32){
  <!-- New York -->
  <app-new-york-state-form
    [policyDetails]="this.policyDetails()"
  ></app-new-york-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 33){
  <!-- North Carolina -->
  <app-north-carolina-state-form
    [policyDetails]="this.policyDetails()"
  ></app-north-carolina-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 34){
  <!-- North Dakota -->
  <app-north-dakota-state-form
    [policyDetails]="this.policyDetails()"
  ></app-north-dakota-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 35){
  <!-- Ohio -->
  <app-ohio-state-form
    [policyDetails]="this.policyDetails()"
  ></app-ohio-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 36){
  <!-- Oklahoma -->
  <app-oklahoma-state-form
    [policyDetails]="this.policyDetails()"
  ></app-oklahoma-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 37){
  <!-- Oregon -->
  <app-oregon-state-form
    [policyDetails]="this.policyDetails()"
  ></app-oregon-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 38){
  <!-- Pennsylvania -->
  <app-pennsylvania-state-form
    [policyDetails]="this.policyDetails()"
  ></app-pennsylvania-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 39){
  <!-- Rhode Island -->
  <app-rhode-island-state-form
    [policyDetails]="this.policyDetails()"
  ></app-rhode-island-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 40){
  <!-- South Carolina -->
  <app-south-carolina-state-form
    [policyDetails]="this.policyDetails()"
  ></app-south-carolina-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 41){
  <!-- South Dakota -->
  <app-south-dakota-state-form
    [policyDetails]="this.policyDetails()"
  ></app-south-dakota-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 42){
  <!-- Tennessee -->
  <app-tennessee-state-form
    [policyDetails]="this.policyDetails()"
  ></app-tennessee-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 43){
  <!-- Texas -->
  <app-texas-state-form
    [policyDetails]="this.policyDetails()"
  ></app-texas-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 44){
  <!-- Utah -->
  <app-utah-state-form
    [policyDetails]="this.policyDetails()"
  ></app-utah-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 45){
  <!-- Vermont -->
  <app-vermont-state-form
    [policyDetails]="this.policyDetails()"
  ></app-vermont-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 46){
  <!-- Virginia -->
  <app-virginia-state-form
    [policyDetails]="this.policyDetails()"
  ></app-virginia-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 47){
  <!-- Washington -->
  <app-washington-state-form
    [policyDetails]="this.policyDetails()"
  ></app-washington-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 48){
  <!-- West Virginia -->
  <app-west-virginia-state-form
    [policyDetails]="this.policyDetails()"
  ></app-west-virginia-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 49){
  <!-- Wisconsin -->
  <app-wisconsin-state-form
    [policyDetails]="this.policyDetails()"
  ></app-wisconsin-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 50){
  <!-- Wyoming -->
  <app-wyoming-state-form
    [policyDetails]="this.policyDetails()"
  ></app-wyoming-state-form>
  } @if(this.policyDetails()?.aul_013_24?.stateId === 52){
  <!-- District of Columbia -->
  <app-district-columbia-state-form
    [policyDetails]="this.policyDetails()"
  ></app-district-columbia-state-form>
  }
  <br />
  <app-aul-001-24 [policyDetails]="this.policyDetails()"></app-aul-001-24>
  <br />
  <app-aul-002-24 [policyDetails]="this.policyDetails()"></app-aul-002-24>
  <br />
  <app-aul-003-24 [policyDetails]="this.policyDetails()" [documentFlags]="this.documentFlags" [addressState]="this.addressState"></app-aul-003-24>
  <br />
  <app-ilp-001-01-04></app-ilp-001-01-04>
  <!--<br/>
      <app-aul-007-24></app-aul-007-24>-->
  <br />
  <app-aul-008-24></app-aul-008-24>
  <br />

  <app-aul-009-24></app-aul-009-24>
  <br />
  <!-- <app-aul-012-24></app-aul-012-24> -->
  <app-priv-0100-6-22></app-priv-0100-6-22>
  <br />
  <app-aul-006-24></app-aul-006-24>
  <br />
  <app-aul-010-24></app-aul-010-24>
  <br />
  <app-aul-011-24></app-aul-011-24>
  <br />
  <!---- Except Residencial all Other Occupancy ---->
  @if (this.isNonCondoAddressPresent()) {
      <app-cp-00-10-10-12></app-cp-00-10-10-12>
  <br />
  }
  <!---- Residencial Occupancy ---->
  @if (this.isAnyCondoAddress()) {
    <app-cp-00-17-10-12></app-cp-00-17-10-12>
  <br />
  }
  <!-- Business Income Limit Added -->
  @if(this.policyDetails()?.cp_00_30_10_12?.[0]){
  <app-cp-00-30-10-12></app-cp-00-30-10-12>
  <br />
  }
  <!-- Cause of Loss: Special Form -->
  @if (
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Special - RCV' || 
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Special - ACV'
) {
  <app-cp-10-30-09-17></app-cp-10-30-09-17>
  <br />
  }
  <!-- Cause of Loss: Basic Form -->
  @if (
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Basic - RCV' || 
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Basic - ACV'
) {  
  <app-cp-10-10-10-12></app-cp-10-10-10-12>
  <br />
  }
  <!-- Cause of Loss: Broad Form -->
  @if (
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Broad - RCV' || 
  this.policyDetails()?.aul_002_24?.causeOfLossDesc === 'Broad - ACV'
) {   <app-cp-10-20-10-12></app-cp-10-20-10-12>
  <br />
  }

  <!-- EQBD form -->
   @if(this.policyDetails()?.aul_001_24?.isEQBDSelected === 1){
    <app-aul-040-26></app-aul-040-26>
  <br />
  <app-cp-eb-2025></app-cp-eb-2025>
  <br />
   }

  <!-- Property Enchancement: Silver -->
  @if(this.policyDetails()?.aul_002_24?.propertyExtCoverageType === 1){
  <app-aul-020-24></app-aul-020-24>
  <br />
  }
  <!-- Property Enchancement: Gold -->
  @if(this.policyDetails()?.aul_002_24?.propertyExtCoverageType === 2){
  <app-aul-021-24></app-aul-021-24>
  <br />
  }
  @if (
    (
      this.policyDetails()?.aul_002_24?.addresses[0]?.occupany === 'Condominiums (Up to 20 Condo Units)' || 
      this.policyDetails()?.aul_002_24?.addresses[0]?.occupany === 'Condominiums (20+ Condo Units)'
    ) &&
    (
      this.policyDetails()?.aul_013_24?.stateId === 8 || 
      this.policyDetails()?.aul_013_24?.stateId === 46 || 
      this.policyDetails()?.aul_013_24?.stateId === 20
    )
  ){
     <app-aul-038-24></app-aul-038-24>
  <br />
  }
  <!-- Ordinance or Law -->
  @if (this.hasOrdinanceOrLawIncluded()) {
    <app-aul-015-24></app-aul-015-24>
  <br />
  }
  <!-- Static: Start -->
  <app-il-00-17-11-98></app-il-00-17-11-98>
  <br />
  <app-cp-00-90-07-88></app-cp-00-90-07-88>
  <br />
  <!-- Static: End -->
  <!-- Loss Payee Entry -->
  @if(this.policyDetails()?.cp_12_18_10_12){
  <app-cp-12-18-10-12></app-cp-12-18-10-12>
  <br />
  }
  <!-- Static: Start -->
  <app-aul-014-24></app-aul-014-24>
  <br />
  <app-cp-02-99-06-07></app-cp-02-99-06-07>
  <br />
  <app-aul-018-24></app-aul-018-24>
  <br />
  <!-- Static: End -->
  <!-- WindStorm and Hail Percentage Deductible -->
  @if(this.policyDetails()?.cp_03_21_10_12){
  <app-cp-03-21-10-12></app-cp-03-21-10-12>
  <br />
  }
  <!-- Static: Start -->
  <app-aul-030-24></app-aul-030-24>
  <br />
  <app-aul-031-24></app-aul-031-24>
  <br />
  <app-aul-039-24></app-aul-039-24>
  <br />
  <!-- Static: End -->
  <!-- TRIA Rejection -->
  @if(this.policyDetails()?.aul_006B_24?.triaRejection){
  <app-aul-006b-24></app-aul-006b-24>
  <br />
  }
  <!-- TRIA Accept -->
  @if(this.policyDetails()?.aul_006A_24?.triaAcceptance){
  <app-aul-006a-24></app-aul-006a-24>
  <br />
  }
  <!-- Windstorm Exclusion -->
  @if(this.policyDetails()?.aul_002_24?.windDeductibleFlag === 1){
  <app-cp-10-54-06-07></app-cp-10-54-06-07>
  <br />
  }
  <!-- Theft Exclusion -->
  @if(this.policyDetails()?.aul_002_24?.vandalismDescription === "Theft Coverage Excluded"){
  <app-cp-10-33-10-12></app-cp-10-33-10-12>
  <br />
  }
  <!-- Water damage Exclusion -->
  @if(this.policyDetails()?.aul_002_24?.waterDamageDescription === "Water Coverage Excluded"){
    <app-aul-034-24></app-aul-034-24>
  <br />
  }
  <!-- Static: Start -->
  <app-aul-019-24></app-aul-019-24>
  <br />
  <app-cp-01-40-07-06></app-cp-01-40-07-06>
  <br />
  <app-cp-10-75-12-20></app-cp-10-75-12-20>
  <br />
  <app-il-09-35-07-02></app-il-09-35-07-02>
  <br />
  <app-aul-022-24></app-aul-022-24>
  <!--<br/>
      <app-aul-023-24></app-aul-023-24>
      <br/>
      <app-aul-028-24></app-aul-028-24>-->
  <br />
  <app-aul-029-24></app-aul-029-24>
  <br />
  <app-aul-016-24></app-aul-016-24>
  <br />
  <app-aul-032-24></app-aul-032-24>
  <br />
  <app-aul-027-24></app-aul-027-24>
  <br />
  <app-aul-026-24></app-aul-026-24>
  <br />
  <app-aul-024-24></app-aul-024-24>
  <br />
  <app-aul-025-24></app-aul-025-24>
  <!-- <br/>
      <app-aul-033-24></app-aul-033-24>-->
  <br />
  <app-aul-035-24></app-aul-035-24>
  <!-- <br/>
      <app-aul-036-24></app-aul-036-24>-->
  <br />
  <app-aul-037-24></app-aul-037-24>
  <br />
 
  <!-- Static: End -->
</div>

@if(this.isGeneratingPDF()) {
<app-spinner></app-spinner>
}
